const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EPIRB_MAKE_TYPES_RETRIEVED":
            return action.epirbMakes;

        default:
            return state;
    }
}
